/**
 * Session limits the screens apply. The values in use come from the settings store (api/Settings/Public,
 * via PublicSettingsService: sessions.launch-window-minutes and sessions.date-picker-forward-days); these
 * constants are the fallbacks when that read fails, and equal the values the screens used before.
 */

/** A session can be launched from this many minutes before it starts until this many minutes after it ends. */
export const SESSION_LAUNCH_WINDOW_MINUTES = 90;

/** The session date picker allows dates up to this many days from today (never past the booking's end). */
export const SESSION_DATE_PICKER_FORWARD_DAYS = 7;
